var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "optimization-page" }, [
    _vm.$route.query.campaign_type == "2"
      ? _c("div", { staticClass: "hero-panel" }, [
          _c("div", { staticClass: "hero-content" }, [
            _c("h1", [
              _c("span", { staticClass: "wave" }, [_vm._v("👋")]),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("OptWelcome", { name: _vm.user.user_name })) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "hero-subtitle" }, [
              _vm._v(_vm._s(_vm.$t("OptHeroSubtitle"))),
            ]),
            _c("p", { staticClass: "hero-copy" }, [
              _vm._v(" " + _vm._s(_vm.$t("OptHeroCopy")) + " "),
            ]),
            _c("p", {
              staticClass: "hero-subtitle",
              domProps: { innerHTML: _vm._s(_vm.$t("OptHeroFlow")) },
            }),
            _c("p", { staticClass: "hero-copy" }, [
              _vm._v(_vm._s(_vm.$t("OptHeroTakeover"))),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.$route.query.campaign_type == "1"
      ? _c("div", { staticClass: "hero-panel" }, [
          _c("div", { staticClass: "hero-content" }, [
            _c("h1", [
              _c("span", { staticClass: "wave" }, [_vm._v("👋")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("OptSaleWelcome", { name: _vm.user.user_name })
                  ) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "hero-copy" }, [
              _vm._v(" " + _vm._s(_vm.$t("OptSaleCopy1")) + " "),
            ]),
            _c("p", { staticClass: "hero-copy" }, [
              _vm._v(" " + _vm._s(_vm.$t("OptSaleCopy2")) + " "),
            ]),
            _c("p", { staticClass: "hero-copy" }, [
              _vm._v(" " + _vm._s(_vm.$t("OptSaleCopy3")) + " "),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.$route.query.campaign_type == "2"
      ? _c(
          "div",
          { staticClass: "info-grid" },
          _vm._l(_vm.infoCards, function (card) {
            return _c(
              "article",
              { key: card.title, staticClass: "info-card" },
              [
                _c("div", { class: ["icon-box", card.iconClass] }, [
                  _vm._v(_vm._s(card.icon)),
                ]),
                _c("h2", [_vm._v(_vm._s(card.title))]),
                _c("div", { staticClass: "summary-box" }, [
                  _vm._v(" " + _vm._s(card.content) + " "),
                ]),
                card.badge
                  ? _c("div", { staticClass: "metric-badge" }, [
                      _vm._v(" " + _vm._s(card.badge) + " "),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.$route.query.campaign_type == "1"
      ? _c(
          "div",
          { staticClass: "info-grid" },
          _vm._l(_vm.saleCards, function (card) {
            return _c(
              "article",
              { key: card.title, staticClass: "info-card" },
              [
                _c("div", { class: ["icon-box", card.iconClass] }, [
                  _vm._v(_vm._s(card.icon)),
                ]),
                _c("h2", [_vm._v(_vm._s(card.title))]),
                _c("div", { staticClass: "summary-box" }, [
                  _vm._v(" " + _vm._s(card.content) + " "),
                ]),
                card.badge
                  ? _c("div", { staticClass: "metric-badge" }, [
                      _vm._v(" " + _vm._s(card.badge) + " "),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c("section", { staticClass: "action-card" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("OptActionTitle")))]),
      _c("p", [_vm._v(" " + _vm._s(_vm.$t("OptActionDesc")) + " ")]),
      _c(
        "div",
        { staticClass: "action-row" },
        [
          _c(
            "a-button",
            {
              staticClass: "action-btn primary",
              attrs: { size: "large", type: "button" },
              on: { click: _vm.handleWatchExample },
            },
            [
              _c("span", { staticClass: "play-icon" }, [_vm._v("►")]),
              _vm._v(" " + _vm._s(_vm.$t("OptWatchExample")) + " "),
            ]
          ),
          _c(
            "a-button",
            {
              staticClass: "action-btn accent",
              attrs: { size: "large", type: "button" },
              on: { click: _vm.handleCreateCampaign },
            },
            [_vm._v(" " + _vm._s(_vm.$t("OptCreateCampaign")) + " ")]
          ),
          _c(
            "a-tooltip",
            { attrs: { placement: "topLeft" } },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("OptStrategyTooltip")))]),
              ]),
              _c(
                "a-button",
                {
                  staticClass: "action-btn outline",
                  attrs: { size: "large", type: "button" },
                  on: { click: _vm.handleBuildStrategy },
                },
                [
                  _c("span", { staticClass: "strategy-icon" }, [_vm._v("🩺")]),
                  _vm._v(" " + _vm._s(_vm.$t("OptStrategyBtn"))),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }